module.exports = __webpack_public_path__ + "img/item3.718a0532.png";